var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-panel"},[_c('div',{staticClass:"p-2 active filter-type"},[_vm._v("Filter by project category")]),_c('div',{staticClass:"option inactive",attrs:{"id":"options-all"},on:{"click":_vm.toggleActive}},[_vm._v("all")])])
}
var staticRenderFns = []

export { render, staticRenderFns }